import { render } from "./AboutOrg.vue?vue&type=template&id=abed3070&scoped=true"
import script from "./_AboutOrg.js?vue&type=script&lang=js&external"
export * from "./_AboutOrg.js?vue&type=script&lang=js&external"

import "./_AboutOrg.less?vue&type=style&index=0&id=abed3070&lang=less&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abed3070"]])

export default __exports__